/* eslint-disable no-loop-func */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { useEffect, useState } from "react";
import { AppState } from "../../../../store/store";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

/* Chart code */
// Themes begin
am4core.useTheme(am4themes_animated);
// Themes end

const EmissionBySource = (para: any) => {
  // Create chart instance

  const ResizeStoreToSetHeight = useSelector(
    (state: AppState) => state.AuraCameraCommon.StackedBarGraphHeight
  );

  const { t } = useTranslation();

  const [displayChart, displayChartUpdate] = useState("none");
  useEffect(() => {
    displayChartUpdate("none");
    var GarphData: any = (para && para?.mapData && para?.mapData[0]) ? para?.mapData[0]?.routes : [];
    // Add data
    let chart = am4core.create("chartdiv", am4charts.XYChart);

    GarphData?.sort((a: any, b: any) => b - a);

    if (GarphData?.length > 20) {
      GarphData = GarphData.slice(0, 20);
    }

    GarphData?.sort((a: any, b: any) => a.RouteTotalleaks - b.RouteTotalleaks);
    // setExGraphData(GarphData);
    chart.data = GarphData;
    let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "routeName";
    categoryAxis.renderer.grid.template.opacity = 0;

    let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.ticks.template.stroke = am4core.color("#495C43");
    valueAxis.renderer.baseGrid.disabled = true;
    if (chart.logo) {
      chart.logo.disabled = true;
    }
    chart.responsive.enabled = true;
    categoryAxis.renderer.minGridDistance = 22;
    categoryAxis.renderer.fontSize = 11;

    // Create series
    // function createSeries(field: any, name: any, color: any) {
    let strokeColor: any = "#fff";
    let val = "{valueX}";

    if (val !== "" && val !== null) {
      let series = chart.series.push(new am4charts.ColumnSeries());

      series.dataFields.valueX = "routeTotalleaks";
      series.dataFields.categoryY = "routeName";
      series.stacked = false;
      series.name = "Leaks";
      series.columns.template.tooltipText = "{categoryY} : {name} {valueX}";
      var labelBullet = series.bullets.push(new am4charts.LabelBullet());
      labelBullet.label.text = "{valueX}";
      labelBullet.label.horizontalCenter = "right";
      labelBullet.label.paddingRight = 15;
      labelBullet.label.fill = am4core.color("#fff");
      // series.columns.template.fill = color;
      //   series.propertyFields.fill = "color";
      series.columns.template.stroke = strokeColor;

      let columnTemplate = series.columns.template;
      columnTemplate.height = am4core.percent(50);
      columnTemplate.maxHeight = 50;
      columnTemplate.column.cornerRadius(0, 5, 0, 5);
      columnTemplate.strokeOpacity = 0;

      series.heatRules.push({
        target: columnTemplate,
        property: "fill",
        dataField: "valueX",
        min: am4core.color("#e5dc36"),
        max: am4core.color("#5faa46"),
      });
      series.mainContainer.mask = undefined;

      series.columns.template.adapter.add("fill", function (fill, target: any) {
        // return chart.colors.getIndex(target.dataItem.index);
        return target?.dataItem?._dataContext?.color;
      });
      labelBullet.label.adapter.add(
        "textOutput",
        function (text: any, target: any) {
          // Hide labels with 0 value
          if (target.dataItem && target.dataItem.valueX == 0) {
            return "";
          }
          return text;
        }
      );
    }
    // }

    if (true) {
      // createSeries("noOfLeaks", "Leaks", "#283250");
      // createSeries("medium", "Medium", "#902c2d");
      // createSeries("low", "Low", "#d5433d");

      setTimeout(() => {
        displayChartUpdate("block");
      }, 300);
    }
  }, [para.mapData]);

  return (
    <>
      {/* {
            para?.filteredValues?.length > 0 ? "" : <div style={{ padding: '24px', textAlign: 'center', marginTop: '40px', color: 'rgba(0,0,0,0.87)' }}>{t("NoRecordsToDisplay")}</div>
        } */}
      <div
        id="chartdiv"
        style={{
          display: displayChart,
          width: "100%",
          height: ResizeStoreToSetHeight ? "550px" : "550px",
        }}
      ></div>
    </>
  );
};

export default EmissionBySource;
